import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { MdAdd, MdAddPhotoAlternate, MdDelete, MdEdit } from "react-icons/md";
import { IconButton } from "@mui/material";
import { Button, Checkbox, Input, Modal, Spin } from "antd";
import { Card, HeaderTitle, Message, ViewInput } from "../../../GlobalStyles";
import CountUp from "react-countup";

export default function BannersAdmin() {
  const [loading, setLoading] = useState(true);
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleModalDelete, setVisibleModalDelete] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [banners, setBanners] = useState([]);
  const [photo, setPhoto] = useState("");
  const [url, setUrl] = useState("");
  const [id, setId] = useState("");
  const [types, setTypes] = useState("");

  useEffect(() => {
    listbanners();
  }, []);

  async function listbanners() {
    await api
      .get(`/banners`)
      .then((response) => {
        setBanners(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function createAndEditBanner() {
    setIsLoadingModal(true);
    if (!url || !photo || !types) {
      toast.warn(
        "Preencha url, visualizadores e imagem para criar novo banner",
      );
    } else {
      const data = new FormData();
      data.append("url", url);
      data.append("types", types);
      if (photo.name) {
        data.append("file", photo, photo.name);
      }
      if (id) {
        await api
          .put(`/banner/${id}`, data)
          .then(async (ok) => {
            toast.success("Banner editado com sucesso");
            listbanners();
            setVisibleModal(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      } else {
        await api
          .post(`/banner`, data)
          .then(async (ok) => {
            toast.success("Banner criado com sucesso");
            listbanners();
            setVisibleModal(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      }
    }
    setIsLoadingModal(false);
  }

  async function deleteBanner() {
    setIsLoadingModal(true);
    await api
      .delete(`/banner/${id}`)
      .then(() => {
        toast.success("Banner excluido com sucesso");
        listbanners();
        setVisibleModalDelete(false);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingModal(false);
  }

  return (
    <Container>
      <HeaderTitle>
        <h1>Banners</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
            marginRight: 20,
          }}
          onClick={() => {
            setId("");
            setUrl("");
            setPhoto("");
            setTypes("admin;");
            setVisibleModal(true);
          }}
        >
          <MdAdd size="20" color="#fff" />
          Novo Banner
        </Button>
      </HeaderTitle>
      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp
              separator="."
              duration={1}
              separator="."
              end={banners.length}
            />
          </Card>
          {banners.length == 0 && <Message>Nenhum banner encontrado</Message>}
          <div className="banners">
            {banners.map((item) => {
              return (
                <div className="banner">
                  <img src={item.photo_url} />
                  <div>
                    <Button
                      className="warning-button"
                      onClick={() => {
                        setId(item.id);
                        setUrl(item.url);
                        setTypes(item.types);
                        setPhoto({ photo_url: item.photo_url });
                        setVisibleModal(true);
                      }}
                    >
                      <MdEdit size={20} />
                      Editar
                    </Button>
                    <Button
                      className="delete-button"
                      onClick={() => {
                        setId(item.id);
                        setUrl(item.url);
                        setTypes(item.types);
                        setPhoto({ photo_url: item.photo_url });
                        setVisibleModalDelete(true);
                      }}
                    >
                      <MdDelete size={20} />
                      Deletar
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      <Modal
        title={id ? "Editar Banner" : "Novo Banner"}
        width={500}
        confirmLoading={isLoadingModal}
        open={visibleModal}
        okText={"SALVAR"}
        cancelText="FECHAR"
        onOk={() => {
          createAndEditBanner();
        }}
        onCancel={() => {
          setVisibleModal(false);
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <ViewInput>
            <p>Imagem (21x7 recomendado)*</p>
            <div
              style={{
                marginTop: 0,
                width: "100%",
                height: 180,
                borderRadius: 10,
                marginBottom: 12,
                justifyContent: "center",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: 160,
                  borderRadius: 10,
                  background: "#fff",
                }}
                src={
                  photo.photo_url
                    ? photo.photo_url
                    : "https://img.freepik.com/vetores-gratis/vetor-de-banner-moderno-mosaico-geometrico-cinza-e-branco_1055-10918.jpg?w=2000"
                }
              />
              <IconButton style={{ width: 40, height: 40 }}>
                <label
                  for="avatar"
                  style={{
                    display: "flex",
                    width: 50,
                    height: 50,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <MdAddPhotoAlternate color="#000" />
                  <input
                    id="avatar"
                    style={{ display: "none" }}
                    type="file"
                    accept="image/"
                    onChange={(file) => {
                      let photo = file.target.files[0];
                      photo.photo_url = URL.createObjectURL(
                        file.target.files[0],
                      );
                      setPhoto(photo);
                    }}
                  />
                </label>
              </IconButton>
            </div>
          </ViewInput>

          <ViewInput>
            <p>Nome*</p>
            <Input
              placeholder="url"
              value={url}
              onChange={(event) => setUrl(event.target.value)}
            />
          </ViewInput>

          <ViewInput style={{ textAlign: "start", marginTop: 5 }}>
            <p>Visivel para:*</p>
            <Checkbox
              style={{ marginLeft: 5 }}
              checked={String(types).indexOf("franqueado;") != -1}
              onChange={(event) => {
                let typesC = types;
                if (String(types).indexOf("franqueado;") != -1) {
                  typesC = typesC.replace("franqueado;", "");
                } else {
                  typesC = typesC + "franqueado;";
                }
                setTypes(typesC);
              }}
            >
              Franqueado
            </Checkbox>
            <Checkbox
              checked={String(types).indexOf("admin;") != -1}
              onChange={(event) => {
                let typesC = types;
                if (String(types).indexOf("admin;") != -1) {
                  typesC = typesC.replace("admin;", "");
                } else {
                  typesC = typesC + "admin;";
                }
                setTypes(typesC);
              }}
            >
              Admin
            </Checkbox>
            <Checkbox
              checked={String(types).indexOf("credenciado;") != -1}
              onChange={(event) => {
                let typesC = types;
                if (String(types).indexOf("credenciado;") != -1) {
                  typesC = typesC.replace("credenciado;", "");
                } else {
                  typesC = typesC + "credenciado;";
                }
                setTypes(typesC);
              }}
            >
              Credenciado
            </Checkbox>
            <Checkbox
              checked={String(types).indexOf("tecnico;") != -1}
              onChange={(event) => {
                let typesC = types;
                if (String(types).indexOf("tecnico;") != -1) {
                  typesC = typesC.replace("tecnico;", "");
                } else {
                  typesC = typesC + "tecnico;";
                }
                setTypes(typesC);
              }}
            >
              Técnico
            </Checkbox>
          </ViewInput>
        </div>
      </Modal>

      <Modal
        title="Deseja Excluir Banner?"
        width={500}
        confirmLoading={isLoadingModal}
        open={visibleModalDelete}
        okText={"EXCLUIR"}
        cancelText="CANCELAR"
        onOk={() => {
          deleteBanner();
        }}
        onCancel={() => {
          setVisibleModalDelete(false);
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            style={{
              width: "100%",
              height: 160,
              borderRadius: 10,
              background: "#f0f0f0",
              marginBottom: 15,
              marginTop: 5,
            }}
            src={
              photo.photo_url
                ? photo.photo_url
                : "https://img.freepik.com/vetores-gratis/vetor-de-banner-moderno-mosaico-geometrico-cinza-e-branco_1055-10918.jpg?w=2000"
            }
          />
        </div>
      </Modal>
    </Container>
  );
}
